export const toMap = (input, mergeToMap) => {
    const map = mergeToMap || new Map();
    for (const item of input) {
        if (item.id) {
            map.set(item.id, item);
        }
    }
    return map;
};
//# sourceMappingURL=toMap.js.map